/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import usePostMsgContext from '@apps/containers/WebviewProvider/hooks';
import { Grid, Stack, Theme, useMediaQuery } from '@mui/material';
import createBasePath from '@stack/helpers/lib/createBasePath';
import isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';

import BrandGroupListProps from './props';
import { Title } from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const BrandGroupListView: React.FC<BrandGroupListProps> = (props) => {
  const {
    title,
    titleStyle,
    showTitle = true,
    isNewCar = true,
    brands,
    sx,

    webView = false,
    imageStyles,
    ContainerGridProps,
    ItemGridProps,
    ...restProps
  } = props;

  // =============== HOOKS
  const isTabletView = useMediaQuery((theme: Theme) =>
    theme?.breakpoints?.between('sm', 1000)
  );
  const { t } = useTranslation('common');
  const { clickAction } = usePostMsgContext();
  const { basePath } = createBasePath({
    webView,
    type: isNewCar ? 'cars' : 'news',
  });

  // =============== VARIABLES

  // =============== VIEWS
  const renderBrandItem = (brand: any, index: number) => {
    const href = !isNewCar
      ? `${basePath}/latest/${brand.car_brand_slug}`
      : `${basePath}/${brand.car_brand_slug}`;
    return (
      <Grid key={index} item xs={isTabletView ? 2 : 3} {...ItemGridProps}>
        <Link
          href={href}
          onClick={() => {
            if (!isNewCar || !webView) return;
            clickAction(href, true, {
              title: brand.car_brand_name,
              params: {
                brand: brand.car_brand_slug,
              },
            });
          }}
          style={{
            textDecoration: 'none',
          }}
        >
          <Stack alignItems="center" gap={2}>
            <Image
              src={brand?.car_brand_image}
              alt={brand?.car_brand_name}
              width={'0'}
              height={'0'}
              sizes="100vw"
              style={{
                height: '100%',
                width: '100%',
                maxHeight: isTabletView ? 60 : 44,
                objectFit: 'contain',
                ...imageStyles,
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: 12,
                lineHeight: '16px',
                fontWeight: 700,
                textTransform: 'uppercase',
                textDecoration: 'none',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100%',
                textOverflow: 'ellipsis',
              }}
            >
              {brand.car_brand_name}
            </p>
          </Stack>
        </Link>
      </Grid>
    );
  };
  if (isEmpty(brands)) return null;
  return (
    <Stack
      {...restProps}
      sx={{
        backgroundColor: '#f7f7f7',
        padding: 5,
        gap: 5,
        ...sx,
      }}
    >
      {showTitle && (
        <Title
          style={{
            fontSize: 20,
            ...titleStyle,
          }}
        >
          {title || t('newsByBrand')}
        </Title>
      )}
      <Grid container spacing={5} {...ContainerGridProps}>
        {brands?.map((item, index) => renderBrandItem(item, index))}
      </Grid>
    </Stack>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export const BrandGroupList = memo(BrandGroupListView);
export default BrandGroupList;
